















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import {
    cChainExplorerURL,
    cChainExplorerURL_test,
    DEFAULT_NETWORK_ID,
} from '@/store/modules/network/network'

@Component({})
export default class UtxoBlock extends Vue {
    @Prop() block!: string
    @Prop() nonce!: number

    get cURL() {
        return `${
            DEFAULT_NETWORK_ID === 1
                ? cChainExplorerURL
                : cChainExplorerURL_test
        }/blocks/${this.block}`
    }
}
